import toaster from '@/utils/toaster'

// Surfaces the engine's non-blocking `variable_warnings`: a primary (shared) conversation that uses
// variables defined only for some markets of the group. Markets without a value render an empty
// string at runtime, so we prompt the user to create the missing per-market values.
export function showVariableMarketWarnings(variableWarnings) {
  if (!Array.isArray(variableWarnings) || variableWarnings.length === 0) return

  const lines = variableWarnings.map(warning => {
    const markets = (warning.missing_markets || [])
      .map(market => market.name || market.market_id || market.bot_id)
      .filter(Boolean)
      .join(', ')
    return `“${warning.name}” — missing for: ${markets}`
  })

  const message = 'Some variables are not defined for every market and will resolve to an empty ' +
    'string there. To fix this, give each missing market its own value, or create a global or ' +
    'bot variable with the same name so every market resolves it:\n' + lines.join('\n')

  toaster.warning(message, { timeout: 12000, closeOnClick: true })
}
